import React from 'react';
import {Button } from 'reactstrap';
import PopupWindow from 'components/ModalPopup';
import { connect } from 'react-redux';
import { UserAction } from 'redux/actions';
import { checkPermissions } from 'hooks';

const AutoFollowBtn = (props) => {
    const [autoFollowOpen, setAutoFollowOpen] = React.useState(false);
    let [isAutoFollow, setIsAutoFollow] = React.useState(false);
    React.useEffect(() => {
        if (props.user) {
            setIsAutoFollow(() => (props.user && props.user.auto_follow) ? true : false);
        }
    }, [props.user]);

    React.useEffect(() => {
        setAutoFollowOpen(false);
        setIsAutoFollow(() => (props.autoFollowSuccess && props.autoFollowSuccess.data) ? true : false);
    }, [props.autoFollowSuccess]);

    const handleAutoFollow = (userId) =>{
        props.updateAutoFollow({user_id:userId});
    }
    return (
        <>
            {
                checkPermissions(props.loginData, 'manage_autofollow') ?
                    <PopupWindow
                        buttonStyle={{ marginTop: 10, width: '100%' }}
                        handlePopup={(popup) => { setAutoFollowOpen(popup) }}
                        openWindow={autoFollowOpen}
                        title={(isAutoFollow) ? 'Remove from automatic follow' : 'Add to automatic follow'}
                        launchButtonText={(isAutoFollow) ? 'Remove from automatic follow' : 'Add to automatic follow'}
                        color={(isAutoFollow) ?'secondary':'primary'}
                    >
                        <div>
                            <div>
                                {(isAutoFollow) ? 'Are you sure? Do you want to remove this user from automatic follow?' : 'Are you sure? Do you want to add this user to automatic follow?'}
                            </div>
                            <div style={{ display: 'flex' }}>
                                <Button
                                    style={{ padding: 'auto', width: 100, marginTop: 20, marginRight: 10 }}
                                    size="sm"
                                    onClick={() => handleAutoFollow(props.userId)}
                                    block >
                                    Yes
                                </Button>
                                <Button
                                    color="primary"
                                    style={{ padding: 'auto', width: 100, marginTop: 20 }}
                                    size="sm"
                                    onClick={() => setAutoFollowOpen(false)}
                                    block >
                                    No
                                </Button>
                            </div>
                        </div>
                    </PopupWindow>
                    : <Button style={{ marginTop: 10, width: '100%' }} disabled={true} className={'border-0 btn-disabled'} color="primary" size="sm" >{(isAutoFollow) ? 'Remove from automatic follow' : 'Add to automatic follow'}</Button>
            }
        </>
    );
};

const mapStateToProps = (state) => ({
    user: (state.user && state.user.userProfile && state.user.userProfile.userdetails) ? state.user.userProfile.userdetails : null,
    autoFollowSuccess: (state.user && state.user.autoFollowSuccess) ? state.user.autoFollowSuccess : null,
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
});
const mapDispatchToProps = (dispatch) => ({
    updateAutoFollow: (payload) => dispatch(UserAction.updateAutoFollow(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AutoFollowBtn);
